import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  AddableTitleExtensionFeaturesResponse,
  AddableTitleExtensionFeaturesResponseSchema,
  SaveTitleExtensionEquipmentApiArg,
  TitleExtensionEquipmentRequestBodySchema,
  TitleExtensionEquipmentResponse,
  TitleExtensionEquipmentResponseSchema,
} from './types';

const TITLE_EXTENSION_EQUIPMENT_TAG = {
  type: 'TitleExtensionEquipment' as const,
  id: 'CURRENT',
};
const ADDABLE_TITLE_EXTENSION_FEATURES_TAG = {
  type: 'TitleExtensionEquipment' as const,
  id: 'ADDABLE',
};

const titleExtensionEquipmentBaseApi = omneticApi.enhanceEndpoints({
  addTagTypes: ['TitleExtensionEquipment'],
});

export const titleExtensionEquipmentApi = titleExtensionEquipmentBaseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getTitleExtensionEquipment: build.query<TitleExtensionEquipmentResponse, void>({
      query: () => ({url: '/dms/v1/sales/title-extension-equipment'}),
      providesTags: [TITLE_EXTENSION_EQUIPMENT_TAG],
      extraOptions: {
        responseSchema: TitleExtensionEquipmentResponseSchema,
      },
    }),
    saveTitleExtensionEquipment: build.mutation<void, SaveTitleExtensionEquipmentApiArg>({
      query: (queryArg) => ({
        url: '/dms/v1/sales/title-extension-equipment',
        method: 'PUT',
        body: queryArg.titleExtensionEquipmentRequestBody,
      }),
      invalidatesTags: invalidateOnSuccess([
        TITLE_EXTENSION_EQUIPMENT_TAG,
        ADDABLE_TITLE_EXTENSION_FEATURES_TAG,
      ]),
      extraOptions: {
        requestSchema: TitleExtensionEquipmentRequestBodySchema,
      },
    }),
    resetTitleExtensionEquipment: build.mutation<void, void>({
      query: () => ({
        url: '/dms/v1/sales/title-extension-equipment',
        method: 'DELETE',
      }),
      invalidatesTags: invalidateOnSuccess([
        TITLE_EXTENSION_EQUIPMENT_TAG,
        ADDABLE_TITLE_EXTENSION_FEATURES_TAG,
      ]),
    }),
    getAddableTitleExtensionFeatures: build.query<AddableTitleExtensionFeaturesResponse, void>({
      query: () => ({
        url: '/dms/v1/sales/title-extension-equipment/addable-features',
      }),
      providesTags: [ADDABLE_TITLE_EXTENSION_FEATURES_TAG],
      extraOptions: {
        responseSchema: AddableTitleExtensionFeaturesResponseSchema,
      },
    }),
  }),
});

export const {
  useGetTitleExtensionEquipmentQuery,
  useSaveTitleExtensionEquipmentMutation,
  useResetTitleExtensionEquipmentMutation,
  useGetAddableTitleExtensionFeaturesQuery,
} = titleExtensionEquipmentApi;
